import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpUtil } from '@app/core/util/http.util';
import * as FileSaver from 'file-saver';
import { Observable } from 'rxjs';

@Injectable()
export class FileDownloadService {

  private static MIME_TYPES_SHOW_IN_BROWSER = [
    'application/pdf',
    'image/jpeg',
    'image/png'
  ];

  constructor(private httpUtil: HttpUtil, private snackBar: MatSnackBar) {}

  public async showOrDownloadFile(fileDownload: Observable<HttpResponse<Blob>>): Promise<boolean> {
    let newWindow;
    try {
      newWindow = window.open('', '_blank');
      newWindow.document.write('Dokument wird geladen...');
      const document = await fileDownload.toPromise();
      if (FileDownloadService.MIME_TYPES_SHOW_IN_BROWSER.some(mimeType => mimeType === document.body.type)) {
        newWindow.location.href = URL.createObjectURL(document.body);
      } else {
        newWindow.close();
        const fileName = this.httpUtil.getFileNameFromHttpResponse(document);
        FileSaver.saveAs(document.body, fileName);
      }

    } catch (e) {
      this.snackBar.open('Dokument kann nicht heruntergeladen werden ' + e.message);
      if (newWindow) {
        newWindow.close();
      }
      return false;
    }
    return true;
  }

  public downloadBlobFromParam(blob: Blob, filename: string): void {
    try {
      FileSaver.saveAs(blob, filename);
    } catch (e) {
      this.snackBar.open('Dokument kann nicht heruntergeladen werden ' + e.message);
    }
  }
}
